export const hrefs = [
  { href: '/o-mnie', title: 'O mnie' },
  { href: `/oferta`, title: 'Oferta', isDropdown: true },
  { href: '/em-grupa', title: 'EM Grupa' },
  { href: '/realizacje', title: 'Realizacje' },
  { href: '/kontakt', title: 'Kontakt' },
];
